export const ADD_SESSION = 'ADD_SESSION';